import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { CategoryDocument } from "@/types/category.ts";
import { EntryDocument } from "@/types/entry.ts";

export default function useLegacyIdRedirect() {
  const store = useStore();
  const router = useRouter();

  function checkForLegacyIdAndRedirect(categoryId: string, entryId: string) {
    const defaultRouteParams = {
      styleid: store.getters.getStyleID,
    };

    const category: CategoryDocument =
      store.getters["api/category"](categoryId);

    const isLegacyRouteParam =
      category.legacyId && category.legacyId === categoryId;

    if (!entryId && isLegacyRouteParam) {
      router.push({
        name: "Category",
        params: {
          ...defaultRouteParams,
          categoryID: category._id,
        },
      });

      return;
    }

    const foundLegacyEntry = category.entries?.find(
      (item: EntryDocument) => item.legacyId === entryId
    );

    if (isLegacyRouteParam || foundLegacyEntry) {
      router.push({
        name: "Person",
        params: {
          ...defaultRouteParams,
          categoryID: category._id,
          entryID: foundLegacyEntry?._id ?? entryId,
        },
      });
    }
  }

  return {
    checkForLegacyIdAndRedirect,
  };
}
